// TrendingSidebar.jsx
import React from "react";

const TrendingSidebar = () => (
  <aside className="bg-gray-700 p-6 rounded-lg text-white">
    <h3 className="text-lg">Trending ✨</h3>
    <ul className="mt-4">
      <li className="mt-2"># JavaScript</li>
      <li className="mt-2"># Full Stack</li>
      <li className="mt-2"># Team Work</li>
      <li className="mt-2"># Mobile Dev</li>
      <li className="mt-2"># Interviews</li>
      <li className="mt-2"># Projects</li>
      <li className="mt-2"># Assignment</li>
    </ul>
  </aside>
);

export default TrendingSidebar;
